"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _remoteScriptInjector = require("@insided/shared/utils/remoteScriptInjector");

var _LoadingSpinner = require("@insided/deprecated-control/ui-components/LoadingSpinner");

var _EmptyPage = _interopRequireDefault(require("@insided/deprecated-preact-components/empty-page/EmptyPage"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var HADashboard = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(HADashboard, _Component);

  var _super = _createSuper(HADashboard);

  function HADashboard(props) {
    var _this;

    (0, _classCallCheck2.default)(this, HADashboard);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scriptElement", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      loading: true,
      isError: false,
      errorMessage: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "instanceDomain", '');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "instanceId", '');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "SSOEnabled", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "HACookielessAuth", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sdkUrl", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "instances", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "connectionId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ssoAuthToken", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkForValidConfiguration", function () {
      var _this$instances;

      if (((_this$instances = _this.instances) === null || _this$instances === void 0 ? void 0 : _this$instances.length) !== 1) {
        var _this$instances2;

        _this.setState({
          isError: true,
          errorMessage: "".concat(((_this$instances2 = _this.instances) === null || _this$instances2 === void 0 ? void 0 : _this$instances2.length) === 0 ? 'No' : 'Multiple', " CS Domain URL's found!"),
          loading: false
        });
      }

      if (_this.HACookielessAuth && (!_this.instanceId || !_this.ssoAuthToken)) {
        _this.setState({
          isError: true,
          errorMessage: 'Dashboards are not available because of invalid Single Sign-On(SSO) credentials',
          loading: false
        });
      }

      if (!_this.SSOEnabled) {
        _this.setState({
          isError: true,
          errorMessage: 'Dashboards are not available because Single Sign-On(SSO) is disabled',
          loading: false
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setInstanceProperties", function () {
      var _this$instances3;

      if (((_this$instances3 = _this.instances) === null || _this$instances3 === void 0 ? void 0 : _this$instances3.length) > 0) {
        _this.instanceDomain = _this.instances[0].instanceDomain;
        _this.instanceId = _this.instances[0].instanceId;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScriptLoad", function () {
      var _this$ref, _window, _window$location;

      var haDashboardInstanceProps = {
        el: (_this$ref = _this.ref) === null || _this$ref === void 0 ? void 0 : _this$ref.current,
        targetUrl: _this.instanceDomain,
        SSOEnabled: _this.SSOEnabled,
        queryParams: {
          dashboardSelectorState: 'OPEN',
          honourCookieLessAuth: _this.HACookielessAuth,
          connectionId: _this.connectionId,
          ssoAuthToken: _this.ssoAuthToken,
          instanceId: _this.instanceId,
          parentDomain: (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin,
          csrfToken: (0, _csrfToken.csrfToken)()
        }
      };

      try {
        var _window2, _window2$location, _window$CSApp$createA, _window3, _window3$CSApp;

        _this.setState({
          loading: true,
          isError: false,
          errorMessage: null
        });

        var windowHash = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.hash;

        if (!windowHash.includes('ha') && !windowHash.includes('dashboard')) {
          history.pushState(null, '', '#/ha/dashboard');
        } // @ts-expect-error - this is a global variable injected by the remote entry script


        var haDashboardInstance = (_window$CSApp$createA = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$CSApp = _window3.CSApp) === null || _window3$CSApp === void 0 ? void 0 : _window3$CSApp.createApp(haDashboardInstanceProps)) !== null && _window$CSApp$createA !== void 0 ? _window$CSApp$createA : null;

        if (!haDashboardInstance) {
          throw new Error('Something went wrong!');
        }

        haDashboardInstance.init();

        _this.setState({
          loading: false,
          isError: false,
          errorMessage: null
        });
      } catch (error) {
        _this.setState({
          errorMessage: error.message,
          loading: false,
          isError: true
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScriptError", function () {
      _this.setState({
        errorMessage: 'Something went wrong!',
        loading: false,
        isError: true
      });
    });
    var horizonAnalyticsProps = _this.props.horizonAnalyticsProps;
    var SSOEnabled = horizonAnalyticsProps.SSOEnabled,
        HACookielessAuth = horizonAnalyticsProps.HACookielessAuth,
        sdkUrl = horizonAnalyticsProps.sdkUrl,
        instances = horizonAnalyticsProps.instances,
        connectionId = horizonAnalyticsProps.connectionId,
        ssoAuthToken = horizonAnalyticsProps.ssoAuthToken;
    var _ref = [SSOEnabled, HACookielessAuth, sdkUrl, connectionId, instances, ssoAuthToken];
    _this.SSOEnabled = _ref[0];
    _this.HACookielessAuth = _ref[1];
    _this.sdkUrl = _ref[2];
    _this.connectionId = _ref[3];
    _this.instances = _ref[4];
    _this.ssoAuthToken = _ref[5];

    _this.setInstanceProperties();

    _this.checkForValidConfiguration();

    return _this;
  }

  (0, _createClass2.default)(HADashboard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _utils.trackDashboardUsage)('new-ha-dashboards');

      if (!this.state.isError) {
        this.scriptElement = (0, _remoteScriptInjector.mountRemoteEntryScript)({
          url: this.sdkUrl,
          remoteName: 'ha-dashboard',
          module: 'default'
        }, this.onScriptLoad, this.onScriptError);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          errorMessage = _this$state.errorMessage,
          isError = _this$state.isError;

      if (isError) {
        return (0, _preact.h)(_EmptyPage.default, {
          img_src: "".concat((0, _globals.default)('basePath'), "images/errors/ha-sso-error.png"),
          header: errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'Failed to load HA Dashboard',
          text: "Please contact Gainsight Administrator for assistance."
        });
      }

      return (0, _preact.h)("div", {
        ref: this.ref,
        style: {
          height: 'calc(95vh - 4px)',
          margin: '0 -40px',
          overflow: 'hidden'
        }
      }, ' ', loading && (0, _preact.h)(_LoadingSpinner.LoadingSpinner, {
        height: 32,
        width: 32
      }), ' ');
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      history.pushState(null, '', '/'); // Reset the URL when the component is unmounted
    }
  }]);
  return HADashboard;
}(_preact.Component);

var _default = HADashboard;
exports.default = _default;